var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Paper',{staticClass:"p-4",class:{ pointer: _vm.routerLink }},[_c('div',{staticClass:"d-flex flex-column",on:{"click":_vm.click}},[_c('div',{staticClass:"d-flex flex-row justify-content-center mb-3"},[_c('img',{staticClass:"logo",attrs:{"src":_vm.company.logo}})]),_c('div',{staticClass:"companytitle"},[_vm._v(_vm._s(_vm.company.title))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }